import React from 'react'
import Navbar from './Navbar'

const Education = ()=> {
    return (
        <section className="resume-section" id="education">
            <Navbar/>
            <div className="resume-section-content">
                <h2 className="mb-5">Education</h2>

                <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                    <div className="flex-grow-1">
                        <h3 className="mb-0">University of Kashmir</h3>
                        <div className="subheading mb-3">BCA</div>
                        <div> Bachelor of Computer Applications </div>
                    </div>
                    <div className="flex-shrink-0">
                        <span className="text-primary">March 2010 - April 2013</span>
                    </div>
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between">
                    <div className="flex-grow-1">
                        <h3 className="mb-0">University of Kashmir</h3>
                        <div className="subheading mb-3">MCA</div>
                        <div>Masters of Computer Applications</div>
                    </div>
                    <div className="flex-shrink-0"><span className="text-primary">June 2013 - July 2016</span></div>
                </div>
            </div>
        </section>
    )
}

export default Education
